import React from 'react';

import { Div, DivProps, P, Span } from '@kizi/core-components';

export interface CountdownProps extends DivProps {
  amount: number;
  reverted?: boolean;
}

export const Countdown: React.FC<CountdownProps> = ({
  amount,
  reverted = false,
  ...restProps
}) => {
  return (
    <Div
      variant={reverted ? 'countdownReverted' : 'countdown'}
      bg="supplementary.1"
      {...restProps}
    >
      <P variant="footnoteRegular">
        <Span fontWeight={700}>{amount}</Span> Contracten over
      </P>
    </Div>
  );
};
